import { useParams } from "react-router-dom"
import { useComputed, useSignal } from "@preact/signals-react"
import { useState } from 'react'

import Button from 'react-bootstrap/Button'
import Form from 'react-bootstrap/Form'
import Modal from 'react-bootstrap/Modal'

import { NotificationTypes, addNotification } from "../../../stores/notification-store.js"
import useAccessToken, { accessToken } from "../../../hooks/useAccessToken.js"
import useConfig from "../../../hooks/useConfig"
import { CreateDeviceForm } from "../../../utils/api.js"
import { ComponentDeviceTypeFormsUnsupported } from "../../../utils/constants.js"
import { isset } from "../../../utils/utils.js"

function UploadFormModal({show, handleCancel, deviceTypes, rerenderPage}) {

	const { beId } = useParams()
	const { config } = useConfig()
	useAccessToken()

	const [dummyState, workaround] = useState(false)
	const rerender = () => { workaround(!dummyState) }

	const fileSignal = useSignal(null)
	const diskFileNameSignal = useSignal('')
	const selectedDeviceTypeSignal = useSignal('')
	const userEnteredFormNameSignal = useSignal('')

	const enableUploadButtonSignal = useComputed(() => {
		return isset(selectedDeviceTypeSignal.value)
			&& isset(userEnteredFormNameSignal.value)
			&& isset(diskFileNameSignal.value)
	})

	const handleDeviceTypeChange = function (event) {
		selectedDeviceTypeSignal.value = event.target.value
		rerender()
	}

	const handleUserEnteredFormNameChanged = function (event) {
		userEnteredFormNameSignal.value = event.target.value
	}

	const selectForm = function (event) {
		fileSignal.value = event.target.files[0]
		diskFileNameSignal.value = event.target.files[0].name
	}

	const uploadForm = async function () {
		try {
			const successCallback = async function (){
				addNotification(`Device form uploaded successfully.`, NotificationTypes.SUCCESS, true)
				resetForm()
				handleCancel()
				await rerenderPage()
			}
			const errorCallback = (response) => {
				let msg
				if (response.status == 401) {
					// unauthorized
					msg = 'Unauthorized: Please login from the old environment.'
				} else if (response.status == 500) {
					msg = "Internal server error."
				} else {
					msg = `Failed to upload form. Status: ${response.statusText}`
				}
				let error = new Error(msg)
				error.code = ''.concat(response.status)
				addNotification("Unable to upload form: ".concat(error.toString()), NotificationTypes.ERROR, true)
				handleCancel()
			}
			await CreateDeviceForm(beId, selectedDeviceTypeSignal.value, userEnteredFormNameSignal.value, "", diskFileNameSignal.value, fileSignal.value, successCallback, errorCallback, config.value, accessToken.value)
		}
		catch (x) {
			console.trace(x.toString())
			window.alert("Caught exception ".concat(x.toString()))
		}
	}

	function resetForm() {
		//enableUploadButtonSignal.value = false
		diskFileNameSignal.value = null
		selectedDeviceTypeSignal.value = null
		userEnteredFormNameSignal.value = null
		document.getElementById("uploadFormForm").reset()
	}

	const deviceTypeSupportsForms = function (type) {
		return !Object.prototype.hasOwnProperty.call(ComponentDeviceTypeFormsUnsupported, type)
	}

	function SelectOptions({ items }) {
		let options = []
		if (items && items.length) {
			for (let i = 0; i < items.length; i++) {
				const item = items[i]
				if (deviceTypeSupportsForms(item.key)) {
					options.push(<option key={item.key} value={`${item.key}`}>{`${item.name}`}</option>)
				}
				
			}
		}
		return options.length == 0? null : options
	}

	return (
		<Modal show={show} onHide={handleCancel}>
			<Modal.Header closeButton>
				{/*<Button type="button" className="close" aria-hidden="true" onClick={handleCancel}>&times;</Button>*/}
				<Modal.Title>Upload Form</Modal.Title>
			</Modal.Header>
			<Form id="uploadFormForm">
				<Modal.Body>
					<Form.Group>
						<Form.Label htmlFor="userEnteredFormName" /*className="col-xs-4 cols-sm-4 control-label"*/>Name</Form.Label>
						<div /*className="col-xs-8 cols-sm-6"*/>
							<Form.Control id="userEnteredFormName" name="userEnteredFormName" className="form-control" value={userEnteredFormNameSignal.value} type="text" required={true} placeholder={'Enter form name'} onChange={handleUserEnteredFormNameChanged}></Form.Control>
						</div>
					</Form.Group>
					<Form.Group>
						<Form.Label /*className="col-xs-3 control-label"*/ htmlFor="deviceType">Device Type</Form.Label>
						<div /*className="col-xs-9"*/>
							<Form.Select id="deviceType" name="deviceType" className='form-control' required aria-required="true" onChange={handleDeviceTypeChange} value={selectedDeviceTypeSignal.value}>
								<option value=''>Select Device Type</option>
								<SelectOptions items={deviceTypes}></SelectOptions>
							</Form.Select>
						</div>
					</Form.Group>
					<Form.Group>
						<Form.Label /*className="col-xs-3 control-label"*/ htmlFor="forms"></Form.Label>
						<div /*className="col-xs-9"*/>
							<Form.Control type="file" id="formFileInput" name="forms" accept=".tgz,.zip" onChange={selectForm} />
						</div>
						<div /*className="col-xs-9"*/>
							<Form.Label>{diskFileNameSignal.value}</Form.Label>
						</div>
					</Form.Group>
				</Modal.Body>
				<Modal.Footer className="modal-footer">
					<Button type="button" onClick={handleCancel}>Cancel</Button>
					<Button type="button" onClick={uploadForm} disabled={!enableUploadButtonSignal.value}>Upload</Button>
				</Modal.Footer>
			</Form>
		</Modal >
	)
}

export default UploadFormModal